export function useMapConsigneeAddress(data, modelValue) {

    modelValue.consignee.consigneeContacts = [];

    modelValue.consignee.id = data.id;
    modelValue.consignee.consigneeAddressLine1 = data.addressLine1;
    modelValue.consignee.consigneeAddressLine2 = data.addressLine2;
    modelValue.consignee.consigneeCity = data.city;

    if (data.country) {
        modelValue.consignee.consigneeCountry = modelValue.metaData.countries.find(c => c.id === data.country).value;
    }

    modelValue.consignee.consigneeCounty = data.county;
    modelValue.consignee.consigneePostcode = data.postCode;
    modelValue.consignee.consigneeVatNumber = data.vatNumber;

    modelValue.isUpdate.consignee = true;

    if(data.contacts) {

        data.contacts.forEach(contact => {
            modelValue.consignee.consigneeContacts.push(contact)
        })
    }

}
